/**
 * Accordion Section - Smooth Accordion Functionality
 * ADA-compliant, SEO-friendly, and optimized
 */

(function() {
  'use strict';

  // Check if reduced motion is preferred
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const transitionDuration = prefersReducedMotion ? 0 : 400;

  /**
   * Initialize accordion functionality
   */
  function initAccordion() {
    const accordionSections = document.querySelectorAll('.accordion-section');
    
    if (accordionSections.length === 0) {
      return;
    }

    accordionSections.forEach(function(section) {
      const accordionHeaders = section.querySelectorAll('.accordion-header');
      
      if (accordionHeaders.length === 0) {
        return;
      }

      // Ensure all accordions are closed by default
      accordionHeaders.forEach(function(header) {
        const content = header.nextElementSibling;
        if (content && content.classList.contains('accordion-content')) {
          header.classList.remove('active');
          header.setAttribute('aria-expanded', 'false');
          content.classList.remove('active');
          content.style.maxHeight = prefersReducedMotion ? '0px' : '0px';
        }
      });

      accordionHeaders.forEach(function(header) {
        // Skip if already initialized
        if (header.dataset.accordionInitialized === 'true') {
          return;
        }

        header.dataset.accordionInitialized = 'true';

        // Add click event listener
        header.addEventListener('click', function() {
          handleAccordionToggle(header, section);
        });

        // Add keyboard support
        header.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleAccordionToggle(header, section);
          }
        });
      });
    });
  }

  /**
   * Handle accordion toggle
   * @param {HTMLElement} header - The accordion header element
   * @param {HTMLElement} section - The parent section element
   */
  function handleAccordionToggle(header, section) {
    const content = header.nextElementSibling;
    
    if (!content || !content.classList.contains('accordion-content')) {
      return;
    }

    const isActive = header.classList.contains('active');
    const isExpanded = header.getAttribute('aria-expanded') === 'true';

    // Close all other accordions in the same section (optional - remove if you want multiple open)
    const allHeaders = section.querySelectorAll('.accordion-header');
    const allContents = section.querySelectorAll('.accordion-content');
    
    allHeaders.forEach(function(h) {
      if (h !== header) {
        h.classList.remove('active');
        h.setAttribute('aria-expanded', 'false');
      }
    });

    allContents.forEach(function(c) {
      if (c !== content) {
        closeAccordion(c);
      }
    });

    // Toggle current accordion
    if (isActive) {
      closeAccordion(content);
      header.classList.remove('active');
      header.setAttribute('aria-expanded', 'false');
    } else {
      openAccordion(content);
      header.classList.add('active');
      header.setAttribute('aria-expanded', 'true');
    }
  }

  /**
   * Open accordion with smooth animation
   * @param {HTMLElement} content - The accordion content element
   */
  function openAccordion(content) {
    if (prefersReducedMotion) {
      content.style.maxHeight = 'none';
      content.classList.add('active');
      return;
    }

    // Set initial state
    content.style.maxHeight = '0px';
    content.classList.add('active');
    
    // Force reflow
    content.offsetHeight;
    
    // Get the actual height
    const scrollHeight = content.scrollHeight;
    const paddingTop = parseInt(window.getComputedStyle(content).paddingTop, 10);
    const paddingBottom = parseInt(window.getComputedStyle(content).paddingBottom, 10);
    const totalHeight = scrollHeight + paddingTop + paddingBottom;
    
    // Animate to full height
    content.style.maxHeight = totalHeight + 'px';
    
    // Clean up after animation
    setTimeout(function() {
      if (content.classList.contains('active')) {
        content.style.maxHeight = '';
      }
    }, transitionDuration);
  }

  /**
   * Close accordion with smooth animation
   * @param {HTMLElement} content - The accordion content element
   */
  function closeAccordion(content) {
    if (prefersReducedMotion) {
      content.style.maxHeight = '0px';
      content.classList.remove('active');
      return;
    }

    // Get current height
    const currentHeight = content.scrollHeight;
    const paddingTop = parseInt(window.getComputedStyle(content).paddingTop, 10);
    const paddingBottom = parseInt(window.getComputedStyle(content).paddingBottom, 10);
    const totalHeight = currentHeight + paddingTop + paddingBottom;
    
    // Set explicit height for animation
    content.style.maxHeight = totalHeight + 'px';
    
    // Force reflow
    content.offsetHeight;
    
    // Animate to 0
    content.style.maxHeight = '0px';
    content.classList.remove('active');
    
    // Clean up after animation
    setTimeout(function() {
      if (!content.classList.contains('active')) {
        content.style.paddingTop = '0';
        content.style.paddingBottom = '0';
      }
    }, transitionDuration);
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAccordion);
    } else {
      initAccordion();
    }
  }

  // Initialize
  init();

  // Re-initialize for dynamically loaded content (if needed)
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAccordion);
    document.addEventListener('shopify:section:reorder', initAccordion);
  }
})();

